import React from 'react';
import { FadeIn, Section } from './Shared';
import { XCircle } from 'lucide-react';
export const WhyFailedSection = () => {
  const reasons = ['Las dietas atacan calorías, no el hígado', 'El ejercicio sin energía empeora el agotamiento', 'Los “detox” comerciales no solucionan la raíz'];
  return <Section bg="white" data-id="element-321">
      <FadeIn data-id="element-322">
        <div className="text-center mb-8" data-id="element-323">
          <h2 className="text-3xl md:text-4xl font-bold mb-4" data-id="element-324">
            No fallaste tú.{' '}
            <span className="text-brand-teal" data-id="element-325">Falló el enfoque.</span>
          </h2>
        </div>
      </FadeIn>

      <div className="max-w-2xl mx-auto space-y-3 mb-8" data-id="element-326">
        {reasons.map((reason, index) => <FadeIn key={index} delay={index * 0.1} data-id="element-327">
            <div className="flex items-center gap-4 p-5 rounded-xl bg-gray-50 border border-gray-100" data-id="element-328">
              <XCircle className="w-6 h-6 text-red-400 flex-shrink-0" data-id="element-329" />
              <p className="text-lg text-gray-700 font-medium" data-id="element-330">{reason}</p>
            </div>
          </FadeIn>)}
      </div>

      <FadeIn delay={0.4} data-id="element-331">
        <div className="bg-brand-cream p-6 rounded-2xl text-center max-w-3xl mx-auto border border-brand-teal/10" data-id="element-332">
          <p className="text-xl md:text-2xl font-heading text-brand-charcoal italic" data-id="element-333">
            "Es como intentar arreglar un motor… sin limpiar el filtro."
          </p>
        </div>
      </FadeIn>
    </Section>;
};